import { render, staticRenderFns } from "./bar-alarm.vue?vue&type=template&id=a0d8acdc&scoped=true"
import script from "./bar-alarm.vue?vue&type=script&lang=js"
export * from "./bar-alarm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d8acdc",
  null
  
)

export default component.exports